








































import {Component, Vue} from "vue-property-decorator"
import ErrorMessage from "@/components/ErrorMessage.vue"
import {vxm} from "@/store"
import {Validation} from "@/lib/Validation"

@Component({components: {ErrorMessage}})
export default class ForgetPassword extends Vue {

  private email: string = ""
  private password: string = ""

  private errors: object = {}

  private loading: boolean = false

  async onResetYourPassword() {

    this.errors = {}
    if (!this.validate()) return

    this.loading = true
    try {
      await vxm.auth.resetPassword({
        email   : this.email
      })
      await this.$router.push({name: "Home"})
    } catch (e) {
      console.error(e)
      // if (e && e.hasOwnProperty("code")) {
      //   switch (e.code) {
      //     case "UserNotFoundException":
      //     case "NotAuthorizedException":
      //       this.errors = {general: ["Incorrect mail address or password."]}
      //       break
      //     default:
      //       this.errors = {general: ["Server Error."]}
      //       console.log(e)
      //   }
      // } else {
      //   this.errors = {general: ["Server Error."]}
      //   console.log("不明なエラー", e)
      // }
    } finally {
      this.loading = false
    }
  }

  validate(): boolean {

    const validation = new Validation({
      email   : {required: true}
    })

    const check: boolean = validation.validate({
      email   : this.email
    })

    if (!check) this.errors = validation.getErrors()

    return check
  }
}
